// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__28zql","label":"SetPasswdForm_label__1PX2T"};